// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._53wwXTvsx{display:inline-flex}._2k1yTKJTx{position:absolute;cursor:default;border-radius:2px;box-shadow:none;color:white;display:inline-block;z-index:1;width:auto;margin:4px 0;max-width:310px}._2k1yTKJTx._612oyOm1x{padding:16px;width:310px;white-space:normal}.vWwrgUHHx{}.FOTL5w3wx{cursor:pointer}.UkGZCBQax{top:auto;bottom:100%}._2pXFBQqcx{left:auto;right:0}._6iHxXTibx{color:white}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"container": "_53wwXTvsx",
	"tooltip": "_2k1yTKJTx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["padding-squish-s"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["paragraph-m"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["dark-overlay"] + "",
	"multiline": "_612oyOm1x",
	"multilineContainer": "vWwrgUHHx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["paragraph-s"] + "",
	"icon": "FOTL5w3wx",
	"upward": "UkGZCBQax",
	"right": "_2pXFBQqcx",
	"title": "_6iHxXTibx"
};
module.exports = exports;
